import { ModulesPage } from './ModulesPage'
import { PackagesPage } from './PackagesPage'

/**
 * `saas-catalog` - the tiers and the modules they contain.
 *
 * Second of `SAAS.md` §3's seven packages, and the one FB-505's recommended order put first: §3 says
 * this pair *"drives tenant module-gating everywhere else"*, so what a tier contains decides what
 * every other screen in the platform is allowed to do. **Five endpoints had no caller** before §3.3.
 */
export const saasCatalogModule = {
  name: 'saas-catalog',
  routes: [
    { path: '/packages', page: 'packages', component: PackagesPage },
    { path: '/modules', page: 'modules', component: ModulesPage },
  ],
} as const

export { ModulesPage } from './ModulesPage'
export { PackagesPage } from './PackagesPage'
export {
  CATEGORY_LABELS,
  CATEGORY_ORDER,
  categoryIsFull,
  categoryLabel,
  draftProblem,
  groupByCategory,
  hasName,
  matchesModuleSearch,
  modulesOf,
  packagesByModule,
  packagesOf,
  reorderedIds,
  slugProblem,
  toggledCategory,
  toggledModule,
  type CatalogModule,
  type CatalogPackage,
  type CategoryGroup,
} from './catalog'
